import { Component, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioGroup, MatRadioButton} from '@angular/material/radio';
import { Trainingreq } from '../../services/training/training-req.interface';
import { TrainingReqService } from '../../services/training/training-req.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-training-req',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatRadioButton,
    MatRadioGroup
],
    templateUrl: './training-req.component.html',
    styleUrl: './training-req.component.css'
})
export class TrainingReqComponent implements OnInit {
    isLoading = false;

    form: FormGroup
    
    constructor(private router: Router, private fb: FormBuilder, private trainingReqService: TrainingReqService ) {
    
    }

      ngOnInit(): void {
        this.form = this.fb.group({
          email: [null, Validators.compose([Validators.required])],
          type: [null, Validators.compose([Validators.required])],
          reason: [null, Validators.compose([Validators.required])],
          date: [null, Validators.compose([Validators.required])],
          cost: [null],
          online: [null, Validators.compose([Validators.required])],
          desc: [null],
        })
      }
      create(): void {
        if (this.form.invalid) {
          return;
        }
        this.isLoading = true;

        const newTrainingReq: Trainingreq = {
          email: this.form.controls['email'].value as string,
          type: this.form.controls['type'].value as string,
          reason: this.form.controls['reason'].value as string,
          date: this.form.controls['date'].value as Date,
          cost: this.form.controls['cost'].value as string,
          online: this.form.controls['online'].value as string,
          desc: this.form.controls['desc'].value as string,
        };
        this.trainingReqService.createTrainingReq(newTrainingReq).subscribe(() => {
          this.router.navigate(['success']);
          this.isLoading = false;
        }, err => {
          console.error('Error, submission failed', err);
          this.isLoading = false;
        });
      }

}
